import { ItemSaldo } from '../@types';
import aqilaApi from './aqila-api';

class ItensSaldo {
  private readonly endpoint = '/v1/itens/saldo';

  async saldos({
    propriedadeId,
    operacaoItem,
    possuiTratamento,
    sementeValidaTratamento,
    descricao,
    noPaginate,
    item,
  }: SaldosParams) {
    const params = {
      operacaoItem,
      propriedade: propriedadeId,
      possuiTratamento,
      sementeValidaTratamento,
      descricao,
      noPaginate,
      item,
    };

    const { data } = await aqilaApi.get<ItemSaldo[]>(this.endpoint, {
      params,
    });

    return data;
  }
}

type OperacaoItem =
  | 'insumo'
  | 'produto'
  | 'combustivel'
  | 'pecas'
  | 'cultivar'
  | 'diversos'
  | 'maquinas'
  | 'benfeitorias'
  | 'adubacao'
  | 'pulverizacao';

type SaldosParams = {
  propriedadeId: number;
  operacaoItem: OperacaoItem;
  possuiTratamento?: boolean;
  sementeValidaTratamento?: boolean;
  descricao?: string;
  noPaginate?: boolean;
  item?: string;
};

export default new ItensSaldo();
